import { render } from "./JSONataErrorExplainer.vue?vue&type=template&id=413dd0a8"
import script from "./JSONataErrorExplainer.vue?vue&type=script&lang=js"
export * from "./JSONataErrorExplainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__